module.exports = {
  url: "https://blog.aawaaz.co",
};
